import { IUpdatedReasonForVisitItemResponse, IUpdatedReasonForVisitResponse }
  from "./updated-reason-for-visit.interface";
import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { UPDATED_REASON_FOR_VISIT } from "./updated-reason-for-visit.query";
import { useQuery } from "@apollo/client";

export const useUpdatedReasonForVisit = () => {
  const [updatedReasonList, setUpdatedReasonList] = useState<{ name: string, options: IOptionGeneric[] }[]>([]);
  const { loading, data } = useQuery<{ fetchReasonsForVisit:IUpdatedReasonForVisitResponse }>(UPDATED_REASON_FOR_VISIT);

  useEffect(() => {
    if (data) {
      setUpdatedReasonList(getReasonsMap(data.fetchReasonsForVisit.items));
    }
  }, [data]);

  return {
    loading,
    updatedReasonList,
  };
};

const getReasonsMap = (items: IUpdatedReasonForVisitItemResponse[]): { name: string, options: IOptionGeneric[] }[] => {
  return items.map((item) => ({
    name: item.name,
    options: item.options.map((e) => ({
      value: e,
      label: e,
    })),
  }));
};
